import List from './List'
// import Detail from './Detail'

const Articles = () => ({
  path: '/tags',
  children: [List()],
})

export default Articles
